import { ElementType } from "react";

import { ReactionType } from "components/server-types";
import {
  ReactionAgreeIcon,
  ReactionClapIcon,
  ReactionDisagreeIcon,
  ReactionDislikeIcon,
  ReactionLaughIcon,
  ReactionLikeIcon,
  ReactionLoveIcon,
  ReactionWowIcon,
} from "mds/icons";

export const REACTION_ANIMATION_DURATION = 3000;
export const REMOVE_REACTION_DELAY = 300;

// One-off colors not in MDS
const LAUGH_COLOR = "#8D386B";
const LOVE_COLOR = "#F13359";
const CLAP_COLOR = "#1596B4";

export const REACTION_TO_FILL_COLOR = {
  like: "var(--green)",
  dislike: "var(--yellow)",
  agree: "var(--orange)",
  disagree: "var(--black-tint-40)",
  laugh: LAUGH_COLOR,
  wow: "var(--blue)",
  love: LOVE_COLOR,
  clap: CLAP_COLOR,
};

export const REACTION_TO_COLOR_CLASSES = {
  like: "hover:bg-green data-[selected]:bg-green",
  dislike: "hover:bg-yellow data-[selected]:bg-yellow",
  agree: "hover:bg-orange data-[selected]:bg-orange",
  disagree: "hover:bg-black-tint-40 data-[selected]:bg-black-tint-40",
  laugh: "hover:bg-[#8D386B] data-[selected]:bg-[#8D386B]",
  wow: "hover:bg-blue data-[selected]:bg-blue",
  love: "hover:bg-[#F13359] data-[selected]:bg-[#F13359]",
  clap: "hover:bg-[#1596B4] data-[selected]:bg-[#1596B4]",
};

export const VOTE_TO_COLOR_CLASSES = {
  yes: "hover:bg-green data-[selected]:bg-green",
  no: "hover:bg-red-tint-20 data-[selected]:bg-red-tint-20",
};

export const REACTION_TO_ICON: Record<NonNullable<ReactionType>, ElementType> = {
  like: ReactionLikeIcon,
  dislike: ReactionDislikeIcon,
  agree: ReactionAgreeIcon,
  disagree: ReactionDisagreeIcon,
  laugh: ReactionLaughIcon,
  wow: ReactionWowIcon,
  love: ReactionLoveIcon,
  clap: ReactionClapIcon,
};

export const REACTION_TO_TITLE_KEY = {
  agree: "reactions.reaction_agree",
  clap: "reactions.reaction_clap",
  disagree: "reactions.reaction_disagree",
  dislike: "reactions.reaction_dislike",
  laugh: "reactions.reaction_laugh",
  like: "reactions.reaction_like",
  love: "reactions.reaction_love",
  wow: "reactions.reaction_wow",
} as const;
